export const SECTION_CONSTANTS = {
  REGULAR: {
    value: '180',
    bnValue: '১৮০',
    label: 'Self',
    bnLabel: 'স্বনির্ধারণী'
  },
  REVISED: {
    value: '180(2)',
    bnValue: '১৮০(২)',
    label: 'Revised',
    bnLabel: 'সংশোধিত'
  },
  NORMAL: {
    value: '175',
    bnValue: '১৭৫',
    label: 'Normal',
    bnLabel: 'সাধারণ'
  },
  DELAYED: {
    value: '174',
    bnValue: '১৭৪',
    label: 'Delayed Return',
    bnLabel: 'বিলম্ব রিটার্ন'
  },
};
